import { ErrorMessage } from "formik";
import { FaExclamationCircle } from "react-icons/fa";

const ErrorFieldForm = ({ name, ...props }) => (
    <ErrorMessage name={name} component="div">
        {(msg) => (
            <div {...props} className="text-red-600 font-bold text-xs mt-1 flex items-center gap-1">
                <FaExclamationCircle className="inline-block" />
                <span>{msg}</span>
            </div>
        )}
    </ErrorMessage>
);

export default ErrorFieldForm;